import React from "react";
import { MiniMap, useReactFlow } from "reactflow";
import { Box } from "@mui/material";
import { useAppSelector, useAppDispatch } from "src/stores/redux/hooks";
import { getShowMinimap } from "../helpers/selectors";
import { setShowMinimapAction } from "src/stores/redux/features/flowdesigner/flowdesigner.slice";
import { SidebarCollapse } from "src/generic/icon/customIcons";
import { StriimTypography } from "@striim/striim-ui-v2";

const sxStyles = {
    iconWrapper: {
        backgroundColor: "white",
        border: "1px solid #e0e0e0",
        borderRadius: "12px",
        overflow: "hidden",
        boxShadow: "0px 0px 30px 20px rgba(235, 242, 250, 0.85)"
    },
    collapseIcon: {
        fill: "none",
        width: "20px",
        height: "20px",
        cursor: "pointer"
    },
    clickableRow: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        padding: "8px 14px",
        cursor: "pointer",
        userSelect: "none",
        "&:hover": { backgroundColor: "#f5f7f9" },
        height: "36px"
    },
    minimap: {
        position: "relative",
        bottom: "auto",
        right: "auto",
        margin: 0,
        width: 220,
        height: 150,
        border: "none",
        boxShadow: "none",
        borderTop: "1px solid #e0e0e0"
    }
};

const MinimapButton: React.FC = React.memo(() => {
    const dispatch = useAppDispatch();
    const showMinimap = useAppSelector(getShowMinimap);
    const { setCenter } = useReactFlow();

    return (
        <Box sx={sxStyles.iconWrapper}>
            <Box
                onClick={() => dispatch(setShowMinimapAction(!showMinimap))}
                sx={sxStyles.clickableRow}
                data-test-id="minimap-toggle"
            >
                <SidebarCollapse
                    style={{ ...sxStyles.collapseIcon, transform: showMinimap ? "rotate(270deg)" : "rotate(90deg)" }}
                />
                <StriimTypography variant="caption2" color="#567280" fontWeight={700}>
                    MINI MAP
                </StriimTypography>
            </Box>
            {showMinimap && (
                <MiniMap
                    pannable={true}
                    nodeColor={"#567280"}
                    style={sxStyles.minimap as React.CSSProperties}
                    nodeBorderRadius={10}
                    onClick={(_, position) => setCenter(position.x, position.y, { duration: 500 })}
                />
            )}
        </Box>
    );
});

export default MinimapButton;
